import { apiJSON } from '@shared/utils/api/api.util'

const handleOpenFile = async (endpoint: string) => {
  try {
    const response = await apiJSON(endpoint)

    const fileUrl = response?.fileUrl
    if (fileUrl) {
      window.open(fileUrl, '_blank')
    } else {
      console.error('fileUrl not found in the response')
    }
  } catch (error) {
    console.error('Error fetching file details:', error)
  }
}

export default handleOpenFile
